module.exports = __webpack_public_path__ + "static/media/19.2e6523d9.jpg";